import React, { FC } from 'react';

import { useFormik } from 'formik';

import IconBtn from '../../../../modules/icon-btn/icon-btn';
import Modal from '../../../../modules/modal';
import UiInput from '../../../../modules/ui/ui-input/ui-input';
import { useAppDispatch } from '../../../../store';
import { changePassword } from '../../../../store/actions/auth';

interface IChangePasswordModalProps {
  isOpenModal: boolean;
  setOpenModal: (value: React.SetStateAction<boolean>) => void;
}

type ChangePasswordFormState = {
  password: string;
  newPassword: string;
  newPasswordAgain: string;
};

const ChangePasswordModal: FC<IChangePasswordModalProps> = ({
  isOpenModal,
  setOpenModal,
}) => {
  const dispatch = useAppDispatch();

  const initialState: ChangePasswordFormState = {
    password: '',
    newPassword: '',
    newPasswordAgain: '',
  };

  const formState = useFormik({
    initialValues: initialState,
    validateOnBlur: true,
    validateOnChange: false,
    onSubmit: () => {
      if (
        formState.values.password &&
        formState.values.newPassword &&
        formState.values.newPasswordAgain
      ) {
        dispatch(
          changePassword({
            password: formState.values.password,
            newPassword: formState.values.newPassword,
          })
        ).then(() => {
          handleCancel();
        });
      }
    },
    validate: (values: Partial<ChangePasswordFormState>) => {
      const errors: Record<string, string> = {};

      if (
        values.newPassword &&
        values.newPasswordAgain &&
        values.newPassword !== values.newPasswordAgain
      ) {
        errors.newPasswordAgain = `Пароли не совпадают`;
      }

      return errors;
    },
  });

  const handleCancel = () => {
    formState.setValues({ ...initialState });
    setOpenModal(false);
  };

  const getFieldError = (field: keyof ChangePasswordFormState) =>
    formState.errors[field] ? (
      <div className="form-item__footer red">{formState.errors[field]}</div>
    ) : null;

  return (
    <Modal
      open={isOpenModal}
      onClose={() => setOpenModal(false)}
      header="Смена пароля пользователя"
      className="create-user-modal"
      body={
        <form className="create-user-form">
          <div className="input-container">
            <UiInput
              onChange={formState.handleChange}
              label="Пароль"
              name="password"
              type="password"
              lg
            />
          </div>
          <div className="input-container">
            <UiInput
              name="newPassword"
              type="password"
              onChange={formState.handleChange}
              onInputBlur={formState.handleBlur}
              lg
              label="Новый пароль"
            />
          </div>
          <div className="input-container">
            <UiInput
              name="newPasswordAgain"
              type="password"
              onChange={formState.handleChange}
              onInputBlur={formState.handleBlur}
              lg
              label="Новый пароль еще раз"
            />
            {getFieldError('newPasswordAgain')}
          </div>
        </form>
      }
      footer={{
        left: <IconBtn title="Отмена" onClick={handleCancel} outlined />,
        right: (
          <IconBtn
            disabled={
              !formState.isValid &&
              !formState.values.password &&
              !formState.values.newPassword &&
              !formState.values.newPasswordAgain
            }
            title="Изменить пароль"
            onClick={formState.handleSubmit}
            outlined
          />
        ),
      }}
    />
  );
};

export default ChangePasswordModal;
